var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.132812,
    width: 41.4877,
    height: 41.4877,
    rx: 18.3003,
    fill: "#ED1C00",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7558 11.7832C15.7346 11.7832 11.6641 15.8537 11.6641 20.8749C11.6641 25.8962 15.7346 29.9667 20.7558 29.9667C25.777 29.9667 29.8476 25.8962 29.8476 20.8749C29.8476 15.8537 25.777 11.7832 20.7558 11.7832ZM18.219 20.8754C18.219 22.2767 19.355 23.4126 20.7562 23.4126C22.1575 23.4126 23.2935 22.2767 23.2935 20.8754C23.2935 19.4741 22.1575 18.3382 20.7562 18.3382C19.355 18.3382 18.219 19.4741 18.219 20.8754ZM18.2703 14.8106C18.5944 14.6777 18.9649 14.8328 19.0978 15.1569C19.2307 15.4811 19.0756 15.8516 18.7515 15.9844C17.7707 16.3864 16.9335 17.0739 16.3485 17.9577C16.1551 18.2499 15.7616 18.3299 15.4695 18.1366C15.1774 17.9432 15.0973 17.5496 15.2907 17.2575C16.0161 16.1616 17.0542 15.3091 18.2703 14.8106Z",
    fill: "#ED1C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.820f205895d3ffd8aa43b7e9c4ed5513.svg";
export { ForwardRef as ReactComponent };